import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Http } from '@angular/http';

/*
  Generated class for the AppDescribtion page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-AppDescribtion',
    templateUrl: 'AppDescribtion.html'
})
export class AppDescribtionPage {
    Describtion: any;
    constructor(public http: Http, public navCtrl: NavController, public navParams: NavParams) {
        if (this.navParams.get("Title") != null) {
            this.Describtion = {
                Title: this.navParams.get("Title"),
                Color: this.navParams.get("Color"),
                Text: ''
            };
            if (this.navParams.get("Text") != '') {
                this.http.request('../assets/texts/' + this.navParams.get("Text"))
                    .map(res => res.text())
                    .subscribe(text => {
                        this.Describtion.Text = text;
                    });
            }
            else {
                this.Describtion.Text = this.navParams.get("DataToShow");
            }
        }
        else {
            this.Describtion = {
                Title: "درباره ما",
                Color: "#336699",
                Text: ''
            };
            this.http.request('../assets/texts/AboutArad.txt')
                .map(res => res.text())
                .subscribe(text => {
                    this.Describtion.Text = text;
                });
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/AppDescribtion/AppDescribtion.ts